<script lang="ts">
    import { kirbyFetch } from "../../../api/kirby/api"
    import { lang } from "../../../store"
    import MedialibImage from "../../widgets/MedialibImage.svelte"

    let {
        block,
    }: {
        block: ImageBlock
    } = $props()
    const cnt = block.content
    let link = $state(cnt.img_link)

    function resolveLink(currentLang: string) {
        if (!cnt.img_link?.includes("page://")) return
        kirbyFetch({
            query: `site.index.filterBy('Uuid', 'in', ['${cnt.img_link}'])`,
            select: {
                uuid: true,
                url: true,
            },
        }).then((pages: any) => {
            const pageUrl = pages?.[0]?.url
            if (pageUrl) link = `/${currentLang}/` + pageUrl.split(`/${currentLang}/`).pop()
        })
    }

    // Top-Level: nur SSR (goja löst Promises synchron)
    if (typeof window === "undefined") resolveLink(String($lang || "de"))

    // $effect: Client + SPA-Sprachwechsel
    $effect(() => {
        resolveLink(String($lang || "de"))
    })
</script>

<section class="image-b">
    {#if cnt.img_link}
        <a href={link} target="_blank" rel="noopener noreferrer">
            <MedialibImage id={cnt.img[0]} />
        </a>
    {:else}
        <MedialibImage id={cnt.img[0]} />
    {/if}
</section>

<style lang="less" global>
    @import "../../../css/variables.less";
    .image-b {
        width: 100%;
        overflow: hidden;
        a {
            cursor: pointer;
        }
        img {
            width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
</style>
